import api from "../../utils/axiosInstance";

export const updateUser = async (userId, updateData) => {
  try {
    const payload =
      updateData instanceof FormData
        ? updateData
        : (() => {
            const formData = new FormData();
            Object.entries(updateData || {}).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                formData.append(key, value);
              }
            });
            return formData;
          })();

    const response = await api.patch(`/users/${userId}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    return response.data;
  } catch (error) {
    console.error("Server response:", error.response?.data || error.message);
    throw error;
  }
};

export const changePassword = async ({ userId, newPassword }) => {
  try {
    const response = await api.post("/auth/change-password", { userId, newPassword });
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error.response?.data || error.message);
    throw error;
  }
};

export const updatePassword = async ({ currentPassword, newPassword }) => {
  try {
    const response = await api.post("/auth/update-password", {
      currentPassword,
      newPassword,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating password:", error.response?.data || error.message);
    throw error;
  }
};

export const sendOtp = async (data) => {
  try {
    const response = await api.post("/otp/generate", data);
    return response.data;
  } catch (error) {
    console.error("Error generating OTP:", error.response?.data || error.message);
    throw error;
  }
};

export const validateOtp = async (data) => {
  try {
    const response = await api.post("/otp/verify", data);
    return response.data;
  } catch (error) {
    console.error("Error validating OTP:", error.response?.data || error.message);
    throw error;
  }
};

export const resendOtp = async (data) => {
  try {
    const response = await api.post("/otp/resend", data);
    return response.data;
  } catch (error) {
    console.error("Error resending OTP:", error.response?.data || error.message);
    throw error;
  }
};

export const forgotPassword = async ({ email }) => {
  try {
    const response = await api.post("/auth/forgot-password", {
      email,
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error requesting forgot password:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await api.post("/auth/reset-password", { token, newPassword });
    return response.data;
  } catch (error) {
    console.error("Error resetting password:", error.response?.data || error.message);
    throw error;
  }
};

export const sendEmailVerification = async () => {
  try {
    const response = await api.post("/users/send-email-verification");
    return response.data;
  } catch (error) {
    console.error("Server response:", error.response?.data || error.message);
    throw error;
  }
};

export const verifyEmailToken = async (token) => {
  try {
    const response = await api.get("/users/verify-email", { params: { token } });
    return response.data;
  } catch (error) {
    console.error("Server response:", error.response?.data || error.message);
    throw error;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get("/users/me");
    return response.data;
  } catch (error) {
    console.error("Error fetching current user:", error.response?.data || error.message);
    throw error;
  }
};

export const updateUserPreferences = async (preferences) => {
  try {
    const response = await api.patch("/users/preferences", preferences);
    return response.data;
  } catch (error) {
    console.error("Error updating user preferences:", error.response?.data || error.message);
    throw error;
  }
};
